import { Branch } from '../base/branch';
import { Role } from './role';

export class Unit extends Branch {
    static _type: string = 'Unit';
    i_unit: true = true;

    override load(source?: any): void {
        this.copy(source);

        if (source) {
            const { nodes, branches } = source;

            nodes?.forEach((node: any) => {
                this.nodes.push(new Role(node));
            });

            branches?.forEach((branch: any) => {
                this.branches.push(new Unit(branch));
            });
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Unit;
    }
}
